import { HotelStars } from '@lt/components';

import React from 'react';
import classnames from 'classnames';
import type { Badge } from 'src/components/LabelList/types';

import Wishlist from 'src/components/Wishlist';
import styles from './header.module.css';

import PriceBadgeContainer from '../../containers/PriceBadge';
import Breadcrumbs from '../Breadcrumbs';
import LabelList from '../LabelList';
import ShareSocial from '../ShareSocial';
import ShortInfo from './ShortInfo';

type Breadcrumb = {
  title: string;
  link?: string;
};

type IProps = {
  title: string;
  price: number;
  stars: number;
  breadcrumbs: Breadcrumb[];
  subheader?: string;
  isMobile?: boolean;
  badgeList?: Badge[];
  isHotelOnly: boolean;
  isWishlistAvailable: boolean;
  hotelId: number;
};

const Header = ({
  title,
  price,
  stars,
  breadcrumbs,
  subheader,
  isMobile = false,
  badgeList,
  isHotelOnly,
  isWishlistAvailable,
  hotelId,
}: IProps) => (
  <div
    className={classnames(styles.container, {
      [styles.containerMobile]: isMobile,
    })}
  >
    <div
      className={classnames(styles.starsLocation, {
        [styles.starsLocationMobile]: isMobile,
      })}
    >
      <HotelStars className={styles.hotelStars} value={stars} />
      {breadcrumbs && (
        <Breadcrumbs
          className={classnames({
            [styles.breadcrumbsMobile]: isMobile,
          })}
          baseCls="hotel-breadcrumbs"
          items={breadcrumbs}
          smartFade={!isMobile}
          fullWidth={isMobile}
          isMobile={isMobile}
        />
      )}
      {!isMobile && (
        <ShareSocial
          className={styles.shareSocialDesktop}
          description={subheader}
        />
      )}
      {isMobile && (
        <Wishlist
          wishlistIdentifier={hotelId}
          price={price}
          type="hotel"
          isMobileHotelPage
          forceDesktop
        />
      )}
    </div>
    <div className={styles.row}>
      <div
        className={classnames(styles.headerContent, {
          [styles.headerContentMobile]: isMobile,
        })}
      >
        <div className={styles.title}>
          <h1
            className={classnames(styles.h1, {
              [styles.h1Mobile]: isMobile,
            })}
          >
            <span>{title}</span>
          </h1>
          {!isMobile && (
            <PriceBadgeContainer value={price} isHotelOnly={isHotelOnly} />
          )}
        </div>
        <div
          className={classnames(styles.subHeaderWrapper, {
            [styles.subHeaderWrapperMobile]: isMobile,
          })}
        >
          <LabelList badges={badgeList} />

          {subheader && <ShortInfo text={subheader} isMobile={isMobile} />}
        </div>
      </div>
      {!isMobile && isWishlistAvailable && (
        <Wishlist
          type="hotel"
          price={price}
          wishlistIdentifier={hotelId}
          isHotelPage
        />
      )}
    </div>
    {isMobile && (
      <ShareSocial
        className={styles.shareSocialMobile}
        stickTo="left"
        description={subheader}
      />
    )}
  </div>
);

export default Header;
